// extracted by mini-css-extract-plugin
module.exports = {"input":"_Input_input_1DJlh","icon":"_Input_icon_1KS_V"};